var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"eFPPopup-div1",style:({'top': _vm.top + 'px', 'left': _vm.left + 'px'})},[_c('span',[_vm._v(_vm._s(_vm.popupTissue))])])}
var staticRenderFns = []

export { render, staticRenderFns }